const FREE_FLASHCARD_LIMIT = 10;
const PREMIUM_PRICE_USD = 29.99;
const PREMIUM_PRICE_LABEL = '$29.99/year';

function hasActivePremium(user, now = new Date()) {
  if (!user) {
    return false;
  }

  if (!user.subscriptionRenewsAt) {
    return false;
  }

  return new Date(user.subscriptionRenewsAt) > now;
}

function getFlashcardLimit(user, now = new Date()) {
  return hasActivePremium(user, now) ? null : FREE_FLASHCARD_LIMIT;
}

module.exports = {
  FREE_FLASHCARD_LIMIT,
  PREMIUM_PRICE_USD,
  PREMIUM_PRICE_LABEL,
  hasActivePremium,
  getFlashcardLimit,
};
